export const CATEGORIES = 'categories';
export const PARTNERS = 'partners';
export const BOLD = 'BOLD';
export const ITALIC = 'ITALIC';
export const UNORDERED_LIST_ITEM = 'unordered-list-item';
